package net.maraclinic.app.pages

import androidx.compose.runtime.Composable
import net.maraclinic.app.styles.LandingPageStyleSheet
import org.jetbrains.compose.web.dom.*

@Composable
fun LandingPage() {
    Section(attrs = { classes(LandingPageStyleSheet.Section) }) {
        H1(attrs = { classes(LandingPageStyleSheet.Text) }) {
            Text("Mara Clinic")
        }

        Img(
            src = "logos/mara-clinic-logo-v1.png",
            attrs = { classes(LandingPageStyleSheet.Logo) }
        )

        H2(attrs = { classes(LandingPageStyleSheet.Text) }) {
            Text("Coming Soon...")
        }
    }
}